<template>
    <div>
        <router-link :to="'upcoming-rental/' + tool.id" tag="div" v-for="(tool, index) in tools" :key="index">
            <ToolListItem :tool="tool.listing" :imageLarge="imageLarge">
                <template slot="content">
                    <div class="flex items-center justify-between">
                        <div>
                            <div class="formLabel mt1 mid-gray">From: {{ tool.startDate | moment("MMM DD [at] h:mma")}}</div>
                            <div class="formLabel mid-gray">To: {{ tool.endDate | moment("MMM DD [at] h:mma") }} </div>
                        </div>
                        <img class="grow" v-if="tool.displayDirection && xs" src="@/assets/img/icon_get_directions.svg"/>
                    </div>
                    
                </template>                
                <template slot="icon">
                    <img class="grow" v-if="tool.displayDirection && !xs" src="@/assets/img/icon_get_directions.svg"/>
                </template>            
            </ToolListItem>
        </router-link>
    </div>
</template>

<script>
import ToolListItem from '@/components/global/ToolListItem.vue';

export default {
    components: {
        ToolListItem
    },
    props: {
        tools: {
            type: Array,
            required: true
        },
        imageLarge: {
            type: Array
        }
    },
    computed: {
        xs() {
            return this.$mq === 'xs';
        }
    }
};
</script>
